import { useEffect, useState } from "react";
import CountUp from "react-countup";

const CounterNumber = ({ fallback, ...countUpProps }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return fallback;
    }

    return <CountUp {...countUpProps} enableScrollSpy />;
};

export default function HomeCounter() {
  return (
    <>
    <div className="home-counter">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <div className="counter-row">                   
                        <div>
                            <h4><CounterNumber end={30000} fallback="30000" /></h4>
                            <p>Sq. ft. <br/>Manufacturing Area</p>
                        </div>

                        <div>
                            <h4><CounterNumber end={200} fallback="200" formattingFn={(value) => value.toString().padStart(2, "0")} /></h4>
                            <p>Kitchen Capacity <br/>Per Month</p>
                        </div>

                        <div>
                            <h4><CounterNumber end={3} fallback="3" /></h4>
                            <p>Showrooms</p>
                        </div>

                        <div>
                            <h4><CounterNumber end={12} fallback="12" /><small>+</small></h4>
                            <p>Years of <br/>Experience</p>
                        </div>

                        <div>
                            <h4><CounterNumber end={2500} fallback="2500" separator="" /></h4>
                            <p>Projects Completed <br/>Across India</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
